import SubscribeForm from "@/components/feature/SubscribeForm";

export default function SubscribeSection() {
  return (
    <section className="mx-auto max-w-shell px-4 py-14 md:px-6 md:py-16">
      <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
        <div className="grid gap-8 p-6 md:p-10 lg:grid-cols-[1fr_1.1fr] lg:items-center">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-label uppercase tracking-[0.28em] text-accent-700">
              <span className="inline-block h-3 w-0.5 bg-accent-500" />
              Newsletter
            </p>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              每天一封，把今日更新送到你手上
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              不想一直刷新页面？留下邮箱，我们会在固定时段把当天最重要的几条更新汇总成一份简报，附上原文链接，三分钟看完。
            </p>
            <ul className="mt-5 space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-accent-600" /> 只发内容更新，不发无关推广
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-accent-600" /> 随时可以取消订阅
              </li>
            </ul>
          </div>
          <div className="rounded-lg bg-background-100 p-6 md:p-7">
            <SubscribeForm />
          </div>
        </div>
      </div>
    </section>
  );
}